import React from "react";
import { TwoButtonModal, AlertContentDiv, MessageAlert } from "./styles";
import { DataHeading } from "../../../../../CommonComponents/commonStyles";
import { replacer, retrieveName } from "../../../../../utils/replacer";
import { Types, AlertContent } from "../../../../../CommonComponents/ContentMessages";
import { replaceSelect } from "../../../../../utils/replacer";
const PopUp = props => {
  switch (props.type) {
    case "EXIT": {
      return (
        <TwoButtonModal
          id="exitAlert"
          data-test="ExitAlert"
          title={
            <AlertContent
                page={"Tiff Exchange"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Exit Tiff"}
                property={"field_header"}
            />
          }
          visible={props.visible}
          onOk={props.onOk}
          onCancel={props.onCancel}
          cancelText={
            <AlertContent
                page={"Tiff Exchange"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Exit Tiff"}
                property={"field_alert_button2_text"}
                isButton={true}
            />
        }
          okText={
            <AlertContent
                page={"Tiff Exchange"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Exit Tiff"}
                property={"field_alert_button1_text"}
                isButton={true}
            />
        }
          maskClosable={false}
        >
          <AlertContentDiv>
            <AlertContent
                    page={"Tiff Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Exit Tiff"}
                    property={"field_description"}
                    html={true}
                    defaultMessage=""
                />
          </AlertContentDiv>
        </TwoButtonModal>
      );
    }
    case "OPTION_CHNAGE": {
      return (
        <TwoButtonModal
          id="optionChangeAlert"
          data-test="OptionChangeAlert"
          title={
            <AlertContent
                page={"Tiff Exchange"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Tiff Option Change"}
                property={"field_header"}
            />
          }
          visible={props.visible}
          onOk={props.onOk}
          onCancel={props.onCancel}
          cancelText={
            <AlertContent
                page={"Tiff Exchange"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Tiff Option Change"}
                property={"field_alert_button2_text"}
                isButton={true}
            />
        }
          okText={
            <AlertContent
                page={"Tiff Exchange"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Tiff Option Change"}
                property={"field_alert_button1_text"}
                isButton={true}
            />
        }
          maskClosable={false}
        >
          <AlertContentDiv>
            <AlertContent
                    page={"Tiff Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Tiff Option Change"}
                    property={"field_description"}
                    html={true}
                    defaultMessage=""
              />
          </AlertContentDiv>
        </TwoButtonModal>
      );
    }
    case "FIRST_TIFF_EXCHANGE": {
        return (
            <MessageAlert
              id="firstTiffExchangeAlert"
              data-test="FirstTiffExchangeAlert"
              title={
                <AlertContent
                    page={"Tiff Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"First Tiff"}
                    property={"field_header"}
                />
              }
              visible={props.visible}
              onOk={props.onOk}
              onCancel={props.onCancel}
              okText={
                <AlertContent
                    page={"Tiff Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"First Tiff"}
                    property={"field_alert_button1_text"}
                    isButton={true}
                />
            }
            >
             <DataHeading>
                <AlertContent
                    page={"Tiff Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"First Tiff"}
                    property={"field_description"}
                    html={true}
                    defaultMessage=""
                />
             </DataHeading>
            </MessageAlert>
          );
    }
    case "TIFF_EXCHANGE_MIN": {
        return (
            <MessageAlert
              id="tiffExchangeMinAlert"
              data-test="TiffExchangeMinAlert"
              title={
                <AlertContent
                    page={"Tiff Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Minimum Tiff"}
                    property={"field_header"}
                />
              }
              visible={props.visible}
              onOk={props.onOk}
              onCancel={props.onCancel}
              okText={
                <AlertContent
                    page={"Tiff Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Minimum Tiff"}
                    property={"field_alert_button1_text"}
                    isButton={true}
                />
            }
            >
             <DataHeading>
                <AlertContent
                    page={"Tiff Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Minimum Tiff"}
                    property={"field_description"}
                    html={true}
                    defaultMessage=""
                />
             </DataHeading>
            </MessageAlert>
          );
    }
    case "FLOW_CHANGE": {
      return (
        <TwoButtonModal
          id="flowChangeAlert"
          data-test="FlowChangeAlert"
          title={
            <AlertContent
                page={"Tiff Exchange"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Tiff Flow Change"}
                property={"field_header"}
            />
          }
          visible={props.visible}
          onOk={props.onOk}
          onCancel={props.onCancel}
          cancelText={
            <AlertContent
                page={"Tiff Exchange"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Tiff Flow Change"}
                property={"field_alert_button2_text"}
                isButton={true}
            />
        }
          okText={
            <AlertContent
                page={"Tiff Exchange"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Tiff Flow Change"}
                property={"field_alert_button1_text"}
                isButton={true}
            />
        }
          maskClosable={false}
        >
          <AlertContentDiv>
              <AlertContent
                    page={"Tiff Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Tiff Flow Change"}
                    property={"field_description"}
                    html={true}
                    defaultMessage=""
              />
          </AlertContentDiv>
        </TwoButtonModal>
      );
    }
    case "MAX_POOL_BALANCE": {
      return (
        <MessageAlert
          id="maxPoolAlert"
          data-test="MaxPoolAlert"
          title="Alert"
          visible={props.visible}
          onOk={props.onOk}
          onCancel={props.onCancel}
          okText="OKAY"
        >
         <DataHeading>You have requested more than 90% from {replaceSelect(props.poolName)} pool(s)’ available balance. Please reduce the amount requested or perform an all shares exchange from this pool(s).</DataHeading>
        </MessageAlert>
      );
    }
    case "INTO_TIFF_NEXT_DISABLED": {
      return (
        <MessageAlert
          id="intoTiffNextAlert"
          data-test="IntoTiffNextAlert"
          title="Alert"
          visible={props.visible}
          onOk={props.onOk}
          onCancel={props.onCancel}
          okText="OKAY"
        >
         <DataHeading>Please enter the amount to be exchanged into the TIFF Multi-asset Fund.</DataHeading>
        </MessageAlert>
      );
    }
  }
};

export default PopUp;
